export default {
  "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最初のページの内容"])}
}